module.exports = __webpack_public_path__ + "img/21.101e8e4a.png";